import React from 'react';
import { Wrapper } from './styles/BlogsList.styles';
import BlogItem from './BlogItem';
import { useLanguage } from '../../locales';
const Blogs = ({ blogs }) => {
  const { translation } = useLanguage();
  return (
    <Wrapper>
      {blogs.length ? (
        blogs.map((blog) => <BlogItem key={blog.contentful_id} blog={blog} />)
      ) : (
        <h3>{translation.alert.noPost}</h3>
      )}
    </Wrapper>
  );
};

export default Blogs;
